import { rootApi, getGatewayQuery } from '@web/utils/@reduxjs/rtk-query';

import {
  SharedAPIActions,
  GetStatusPageAlertsQueryPayload,
  GetStatusPageAlertsQueryResult,
} from './types';

// Define a service using a base URL and expected endpoints
export const globalApi = rootApi.injectEndpoints({
  endpoints: build => ({
    /**
     * API: getStatusPageAlerts
     *
     */
    getStatusPageAlerts: build.query<
      GetStatusPageAlertsQueryResult,
      GetStatusPageAlertsQueryPayload
    >({
      query: args =>
        getGatewayQuery<SharedAPIActions, GetStatusPageAlertsQueryPayload>(
          SharedAPIActions.PortalGetStatusPageAlerts,
          args,
        ),
    }),
    // [APPEND NEW APIS ABOVE] < Needed for generating API Hooks seamlessly
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints ("use" + endpoint name with capital letter)
export const {
  useGetStatusPageAlertsQuery,
  // [EXPORT NEW APIS ABOVE] < Needed for generating API Hooks seamlessly
} = globalApi;
